function flTrack(eventName, params) {
  params = params || {};
  try {
    // GA4 gtag
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      return;
    }
    // GA4 via dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });
  } catch(e){}
}

(function () {
  function norm(s) { return (s || "").toString().trim(); }
  function normUpper(s) { return norm(s).toUpperCase(); }

  function parseTags(tagString) {
    // Expect tags joined by "|" from Liquid
    const raw = (tagString || "").split("|").map(t => norm(t)).filter(Boolean);
    return raw;
  }

  function hasMemberOfferTag(tags, code) {
    // tag format: member_offer:POLY544 (case-insensitive)
    const target = `member_offer:${normUpper(code)}`.toLowerCase();
    return tags.some(t => t.toLowerCase() === target);
  }

  // =========================
  // Offer Configuration (one place)
  // =========================
  const OFFERS = [
    {
      key: "HUBBLE10",
      enabled: true,
      code: "HUBBLE10",
      omnisendId: "omnisend-embedded-v2-69bab67dd052b6290405402a",
      title: "Get 10% Off Rose & Hubble Fabrics",
      subtitle: "Mix N Match Across all Designs",
      appliedText: "10% discount is applied ✓",
      appliedLink: "/collections/rose-and-hubble-fabric",
      appliedLinkText: "Mix & match across all Rose & Hubble fabrics",

      // Eligibility rules (any match = eligible)
      match: {
        vendor: ["Rose & Hubble"],   // exact match
        productType: [],            // e.g. ["Polycotton"]
        // tags are handled separately via member_offer:CODE
      }
    },
       {
      key: "JOHNNY10",
      enabled: false,
      code: "JOHNNY10",
      omnisendId: "omnisend-embedded-v2-699c7d9c917b92a165b0cbea",
      title: "Get 10% Off Little Johnny",
      subtitle: "Across all Little Johnny fabrics",
      appliedText: "10% discount is applied ✓",
      appliedLink: "/collections/little-johnny-fabrics",
      appliedLinkText: "Mix & match across all Little Johnny fabrics",

      // Eligibility rules (any match = eligible)
      match: {
        vendor: ["Little Johnny"],   // exact match
        productType: [],            // e.g. ["Polycotton"]
        // tags are handled separately via member_offer:CODE
      }
    },
         {
      key: "EASTER10",
      enabled: false,
      code: "EASTER10",
      omnisendId: "omnisend-embedded-v2-699f1dce24057183d9d93a79",
      title: "Get 10% Off When You Spend £35",
      subtitle: "Across all Easter/Spring fabrics ",
      appliedText: "10% Off Member Discount Applied ✓",
      appliedLink: "/collections/easter",
      appliedLinkText: "When you spend £35 on Easter/Spring prints",

      // Eligibility rules (any match = eligible)
      match: {
        vendor: [],   // exact match
        productType: [],            // e.g. ["Polycotton"]
        // tags are handled separately via member_offer:CODE
      }
    },
        {
      key: "QUILT5",
      enabled: true,
      code: "QUILT5",
      omnisendId: "omnisend-embedded-v2-69bab67dd052b6290405402a",
      title: "Get £5 Off When You Spend £40+",
      subtitle: "Across all quilting cottons ",
      appliedText: "£5 off is applied when you spend £40 ✓",
      appliedLink: "/collections/quilting-fabrics",
      appliedLinkText: "Mix & match across all quilting cottons",

      // Eligibility rules (any match = eligible)
      match: {
        vendor: [],   // exact match
        productType: ["Quilting Cotton"],            // e.g. ["Polycotton"]
        // tags are handled separately via member_offer:CODE
      }
    },
    {
      key: "CANVAS5",
      enabled: false,
      code: "CANVAS5",
      omnisendId: "omnisend-embedded-v2-699cd173ab3b5d06ef4e698a",
      title: "Get £5 Off When You Spend £50+",
      subtitle: "Across all canvas and tapestry fabrics",
      appliedText: "£5 off is applied when you spend £50 ✓",
      appliedLink: "/collections/craft-canvas-fabric",
      appliedLinkText: "Mix & match across all canvas fabrics",

      // Eligibility rules (any match = eligible)
      match: {
        vendor: [],   // exact match
        productType: ["Craft Canvas Fabric"],            // e.g. ["Polycotton"]
        // tags are handled separately via member_offer:CODE
      }
    },
    {
      key: "POLY544",
      enabled: false,
      code: "POLY544",
      omnisendId: "omnisend-embedded-v2-69bab67dd052b6290405402a",
      title: "Buy 4, Get 1 Free",
      subtitle: "Mix & match polycottons",
      appliedText: "Buy 4, Get 1 Free offer is applied ✓",
      appliedLink: "/collections/polycotton-fabrics",
      appliedLinkText: "Mix & match across all polycotton fabrics",

      match: {
        vendor: [],
        productType: ["Polycotton"]
      }
    }
  ];

  // Build global active code list for fl-offer-modal.js (enabled only)
  const ACTIVE_CODES = OFFERS.filter(o => o.enabled).map(o => o.code);
  window.FL_ACTIVE_MEMBER_CODES = ACTIVE_CODES;

  // =========================
  // Render
  // =========================
  function renderOfferHTML(offer) {
    // IMPORTANT: keep structure consistent with your modal JS expectations
    return `
      <div class="fl-offer-root" style="display:none;">
        <div
          class="fl-offer-container"
          data-fl-offer
          data-offer-key="${offer.key}"
          data-discount-code="${offer.code}"
          data-fl-active="0"
          data-omnisend-id="${offer.omnisendId}"
        >
          <div class="fl-offer-image">
            <img
              src="https://cdn.shopify.com/s/files/1/0742/2037/files/member_offer_logo.png?v=1771243094"
              alt="Member offer"
            >
          </div>

          <div class="fl-offer-text">
            <div class="fl-offer-teaser" data-fl-offer-teaser>
              <p class="fl-offer-headline">${offer.title}</p>
              <div class="fl-offer-scope">${offer.subtitle}</div>
              <a href="#" class="fl-offer-link" data-fl-offer-toggle>
                Unlock the Discount 
              </a>
            </div>

            <div class="fl-offer-form" data-fl-offer-form>
              <div id="${offer.omnisendId}"></div>
            </div>

            <div class="fl-offer-applied" data-fl-offer-applied>
              <div class="fl-offer-applied-main">${offer.appliedText}</div>
              <a href="${offer.appliedLink}" class="fl-offer-applied-sub fl-offer-applied-link">
                ${offer.appliedLinkText}
              </a>
            </div>
          </div>
        </div>
      </div>
    `.trim();
  }

  function isEligible(offer, tags, vendor, productType) {
    // 1) explicit tag member_offer:CODE always enables
    if (hasMemberOfferTag(tags, offer.code)) return true;

    // 2) vendor match
    const vendors = (offer.match && offer.match.vendor) || [];
    if (vendors.length && vendors.some(v => v === vendor)) return true;

    // 3) product type match
    const types = (offer.match && offer.match.productType) || [];
    if (types.length && types.some(t => t === productType)) return true;

    return false;
  }

  function injectBaseStylesOnce() {
    if (document.getElementById("fl-member-offer-styles")) return;

    const css = `
      .fl-offer-container{ display:flex; align-items:center; justify-content:left; }
      .fl-offer-image img{ max-width:100%; height:auto; display:block; }
      .fl-offer-text{ color:#87037B; padding-left:20px; }
      .fl-offer-link{
        color:#87037B; font-weight:700; text-decoration:underline;
        cursor:pointer; display:inline-block; margin-top:6px; position:relative; z-index:5;
      }
      .fl-offer-form{
        position:absolute; left:-99999px; top:0;
        width:min(560px, calc(100vw - 32px));
        opacity:0; pointer-events:none;
      }
      .fl-offer-form.is-open{
        position:static; left:auto; top:auto; width:auto; opacity:1; pointer-events:auto;
      }
      .fl-offer-teaser.is-hidden{ display:none; }
      .fl-offer-image.is-hidden{ display:none; }
      .fl-offer-applied{ display:none; margin-top:6px; font-weight:600; }
      .fl-offer-applied.is-on{ display:block; }
    `.trim();

    const style = document.createElement("style");
    style.id = "fl-member-offer-styles";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function init() {
    const mount = document.querySelector("[data-fl-member-offers]");
    if (!mount) return;

    const tags = parseTags(mount.getAttribute("data-tags") || "");
    const vendor = norm(mount.getAttribute("data-vendor") || "");
    const productType = norm(mount.getAttribute("data-product-type") || "");

    const eligibleOffers = OFFERS
      .filter(o => o.enabled)
      .filter(o => isEligible(o, tags, vendor, productType));

    if (!eligibleOffers.length) {
      mount.innerHTML = "";
      return;
    }

    injectBaseStylesOnce();

    // Render ALL eligible offers (supports multiple offers on same template)
    mount.innerHTML = eligibleOffers.map(renderOfferHTML).join("\n");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
